// Ticket restriction options
export const RESTRICTION_OPTIONS = [
  { id: 'restricted-view', label: 'Restricted View', icon: 'eye-off-outline' },
  { id: 'junior-only', label: 'Junior Tickets (All are Junior)', icon: 'people-outline' },
  { id: 'adult-junior', label: 'Adult + Junior Mix', icon: 'people-circle-outline' },
  { id: 'wheelchair', label: 'Wheelchair Accessible', icon: 'accessibility-outline' },
  { id: 'alcohol-free', label: 'Alcohol Free Zone', icon: 'wine-outline' },
  { id: 'family-zone', label: 'Family Zone', icon: 'home-outline' },
];

// Ticket split type options
export const SPLIT_TYPE_OPTIONS = [
  { id: 'singles', label: 'Single Seats', description: 'All seats separated', maxGroup: 1 },
  { id: 'up-to-2', label: 'Up to 2 Together', description: 'Pairs maximum', maxGroup: 2 },
  { id: 'up-to-3', label: 'Up to 3 Together', description: 'Groups of 3 maximum', maxGroup: 3 },
  { id: 'up-to-4', label: 'Up to 4 Together', description: 'Groups of 4 maximum', maxGroup: 4 },
  { id: 'all-together', label: 'All Together', description: 'All seats must be together', maxGroup: -1 },
];

// Function to calculate split groups based on quantity and split type
export const calculateSplitGroups = (quantity: number, splitType: string): string => {
  const option = SPLIT_TYPE_OPTIONS.find(opt => opt.id === splitType);
  if (!option) return '';
  
  if (option.maxGroup === -1) {
    return `${quantity} together`;
  }
  
  if (option.maxGroup === 1) {
    return `${quantity} single seats`;
  }
  
  const groups: number[] = [];
  let remaining = quantity;
  
  while (remaining > 0) {
    if (remaining >= option.maxGroup) {
      groups.push(option.maxGroup);
      remaining -= option.maxGroup;
    } else {
      groups.push(remaining);
      remaining = 0;
    }
  }
  
  // Format the groups nicely
  const groupCounts: { [key: number]: number } = {};
  groups.forEach(group => {
    groupCounts[group] = (groupCounts[group] || 0) + 1;
  });
  
  const parts: string[] = [];
  Object.entries(groupCounts).forEach(([size, count]) => {
    if (count === 1) {
      parts.push(size === '1' ? 'single' : `${size} together`);
    } else {
      parts.push(`${count}x${size}`);
    }
  });
  
  return parts.join(' + ');
};